import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { CLASSROOMS_KEY } from '@teetsh/app/src/queries/classrooms/useClassrooms';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { TAGS_KEY } from '@teetsh/app/src/queries/tags/useTags';
import { TagWithClassrooms } from '@teetsh/app/src/containers/MesAnneesScolaires/School/Tags/types';
import { useTranslation } from 'react-i18next';

function removeTag({
  schoolyearId,
  schoolId,
  tagId,
}: {
  schoolyearId: string;
  schoolId: string;
  tagId: string;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/tags/${tagId}`;
  return request(requestURL, {
    method: 'DELETE',
  });
}

interface Props {
  schoolyearId: string;
  schoolId: string;
}

export default function useRemoveTags(props: Props) {
  const { schoolyearId, schoolId } = props;
  const { notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['schoolyearSettings']);
  const { mutateAsync } = useMutation({
    mutationFn: (tagId: string) => removeTag({ schoolId, schoolyearId, tagId }),
    onMutate: tagId => {
      queryClient.setQueryData<TagWithClassrooms[]>(
        [schoolyearId, schoolId, TAGS_KEY],
        data => (data || []).filter(tt => tt.id !== tagId),
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [CLASSROOMS_KEY],
      });
    },
    onError: () => {
      notifyError({
        title: t('schoolyearSettings:messages.tag.deleteError'),
      });
      queryClient.invalidateQueries({
        queryKey: [schoolyearId, schoolId, TAGS_KEY],
      });
    },
  });
  return mutateAsync;
}
